/* -----------------Child components--------------- */
import SessionConfigContainer from "@features/session-config/containers/SessionConfigContainer";

const SessionCustomizeRoute = () => {
	return <SessionConfigContainer />;
};

export default SessionCustomizeRoute;
